import React from "react";
import styled from "styled-components";

const PanelWrapper = styled.div`
  margin: ${innerProps => innerProps.marginTop || "0"} 16px 24px;
  border-bottom: ${({ theme }) => theme.colors.gray700} solid 1px;
  ${props => props.theme.media.desktopUp`
    margin: ${innerProps => innerProps.marginTop || "0"} 0 0;
    padding: 24px 0;
    border-bottom: none;
  `};
`;

export default ({ marginTop, children }) => (
  <PanelWrapper marginTop={marginTop}>{children}</PanelWrapper>
);
